import React from "react";
import { graphql } from "react-apollo";
import qs from "query-string";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastr";
import THEATER_SIGNUP_MUTATION from "../../../graphql/TheaterSignUp";
import TheaterRegisterForm from "./Form";
import {
  FREE_PLAN,
  FULL_PLAN,
  PRODUCERS_PLAN,
  VENUES_PLAN
} from "../../../constants";

class TheaterRegisterPage extends React.Component {
  constructor(props) {
    super(props);

    const obj = qs.parse(this.props.location.search);
    if ("plan" in obj) {
      const { plan } = obj;
      if (
        plan === VENUES_PLAN ||
        plan === PRODUCERS_PLAN ||
        plan === FULL_PLAN
      ) {
        this.plan = plan;
      } else {
        this.plan = FREE_PLAN;
      }
    }
  }

  handleUserCreation = data => {
    const { mutate, history } = this.props;

    mutate({
      variables: data
    })
      .then(() => {
        this.toastr.success(
          "Tu perfil fue creado exitosamente, confirmaremos tu cuenta a través de un correo electrónico"
        );
        setTimeout(() => {
          history.push({
            pathname: "/",
            state: {
              msg:
                "Tu perfil fue creado exitosamente, confirmaremos tu cuenta a través de un correo electrónico"
            }
          });
        }, 2000);
      })
      .catch(() => {
        this.toastr.error(
          "Ocurrió un error al intentar crear el teatro. Por favor intentalo más tarde"
        );
      });
  };

  render() {
    return (
      <div className="login__page">
        <ToastContainer
          ref={ref => {
            this.toastr = ref;
          }}
          className="toast-top-right"
        />

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-content-box" style={{ maxWidth: "100%" }}>
                <div className="details">
                  <Link to="/">
                    <img
                      src="/img/logos/logo-2.png"
                      className="cm-logo"
                      alt="black-logo"
                    />
                  </Link>
                  <div class="row">
                    <img
                      width="100%"
                      height="auto"
                      style={{ maxWidth: "600px" }}
                      src="/img/banner_escena.jpeg"
                      alt="Imagen restringida"
                    />
                  </div>
                  <h3>Formulario de Registro</h3>
                  <TheaterRegisterForm
                    plan={this.plan}
                    onCreateTheater={this.handleUserCreation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const withMutation = graphql(THEATER_SIGNUP_MUTATION);
export default withMutation(TheaterRegisterPage);



// WEBPACK FOOTER //
// ./src/containers/General/TheaterRegisterPage/index.js